<div class="list-element">
    <div class="list-element__title">
        <ng-content select="[title]"></ng-content>
    </div>

    <div class="list-element__actions">
        <ng-content select="[actions]"></ng-content>
    </div>
</div>
